export default __webpack_public_path__ + "images/24_thumbnail.jpg";